import { Link } from "react-router-dom";

interface Props {
  icon?: string;
  title: string;
  description: string;
  actionLabel?: string;
  actionTo?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  actionTo,
  onAction,
}: Props) {
  const actionClass =
    "inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer";

  return (
    <div className="w-full py-14 md:py-20 flex flex-col items-center text-center px-4 bg-background-50 border border-dashed border-background-300 rounded-lg">
      <div className="w-16 h-16 rounded-full bg-background-200 flex items-center justify-center mb-4">
        <i className={`${icon} text-2xl text-foreground-400`} />
      </div>
      <h3 className="font-heading text-lg font-semibold text-foreground-900">{title}</h3>
      <p className="mt-2 text-sm text-foreground-600 max-w-md leading-relaxed">{description}</p>
      <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
        {actionLabel && actionTo && (
          <Link to={actionTo} className={actionClass}>
            {actionLabel}
            <i className="ri-arrow-right-line" />
          </Link>
        )}
        {actionLabel && onAction && !actionTo && (
          <button type="button" onClick={onAction} className={actionClass}>
            {actionLabel}
          </button>
        )}
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
      </div>
    </div>
  );
}